export default {
  textField: {
    '& .MuiInputLabel-root': {
      color: 'text.dark',
      fontWeight: '300',
      '&.Mui-focused': {
        color: 'text.dark',
      },
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'transparent',
      '& .MuiOutlinedInput-input': {
        fontSize: '14px',
        fontWeight: '300',
        lineHeight: '1.15',
        paddingLeft: 2,
        paddingY: 1.25,
        '&::placeholder': {
          color: 'text.grey.blue_1',
          opacity: 1,
        },
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'background.grey.blue_3',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'background.grey.blue_3',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'background.grey.blue_3',
        borderWidth: '1px',
      },
    },
    '& .MuiFormHelperText-root': {
      fontSize: '12px',
      fontWeight: '300',
    },
    '&.Mui-disabled': {
      opacity: 0.5,
    },
  },
};
